/**
 * Modulo de Grupos de trabalho.
 *
 * Um grupo e a unidade de permissao da plataforma: o usuario nao recebe
 * permissao direta, recebe por pertencer a um grupo. A tela de edicao carrega
 * as duas coisas na mesma pagina -- membros e a arvore de permissoes -- porque
 * no modelo do liberty/auth elas sao inseparaveis: a permissao e gravada em
 * WorkgroupPerm, sempre com (grupo, corporacao, ferramenta).
 *
 * Portado da tela "Gestao de permissao" do admin, que ja fazia exatamente isso.
 */
export const nav = {
    permissao: 'accounts.grupos:ver',
    section: 'Resources',
    title: 'Workgroups',
    icon: 'groups',
    route: '/grupos',
    accordion: false,
};

export default [
    {
        path: '/grupos',
        name: '/grupos',
        component: () => import('./pages/GruposListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.grupos:ver' },
    },
    {
        path: '/grupos/novo',
        name: 'grupo-novo',
        component: () => import('./pages/GrupoPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.grupos:criar' },
    },
    {
        path: '/grupos/editar/:id',
        name: 'grupo-editar',
        component: () => import('./pages/GrupoPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'accounts.grupos:editar' },
    },
];
